// PUT

import axios, { AxiosResponse } from 'axios';
import { UpdateProfileInput } from '../types/update-profile-input.type';
import { ProfileType } from 'types/shared/profile-type.enum';

// /ewosapi/v2/planandprognosis/profile/{profileType}/{profileId}
export const putProfileByType = async (
  profileType: ProfileType,
  profileId: string,
  request: UpdateProfileInput
): Promise<AxiosResponse> => {
  return await axios.put(`/ewosapi/v2/planandprognosis/profile/${profileType}/${profileId}`, request);
};
